import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

interface Props {
    show: boolean;
    id?: number | null;
    initialValue?: string | null;
    onHide: () => void;
    onSubmit: (purchaseOrderInfluencer: string) => void;
}

export const PurchaseOrderModal: React.FC<Props> = ({ show, id, initialValue, onHide, onSubmit }) => {
    const [purchaseOrderInfluencer, setPurchaseOrderInfluencer] = useState('');

    useEffect(() => {
        if (show) {
            setPurchaseOrderInfluencer(initialValue ?? '');
        }
    }, [show, initialValue]);

    const handleSubmit = () => {
        onSubmit(purchaseOrderInfluencer);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Purchase Order {id ? `— ID: ${id}` : ''}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Purchase Order (Influencer)</Form.Label>
                        <Form.Control
                            type="text"
                            value={purchaseOrderInfluencer}
                            onChange={e => setPurchaseOrderInfluencer(e.target.value)}
                            placeholder="Enter purchase order number"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-primary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
